// extracted by mini-css-extract-plugin
export var avatarContainer = "_ep-0";
export var gray = "_ep-f";
export var green = "_ep-c";
export var icon = "_ep-9";
export var image = "_ep-1";
export var lg = "_ep-6";
export var md = "_ep-5";
export var presenceDot = "_ep-b";
export var red = "_ep-d";
export var sm = "_ep-4";
export var status = "_ep-a";
export var xl = "_ep-7";
export var xs = "_ep-3";
export var xxl = "_ep-8";
export var xxs = "_ep-2";
export var yellow = "_ep-e";